var _defs, _g, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRacLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 135.141,
    height: 41.997,
    viewBox: "0 0 135.141 41.997",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.126,
    y1: 1.008,
    x2: 0.928,
    y2: 0.109,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#bfbfbf"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12464",
    "data-name": "Group 12464",
    transform: "translate(-12105.805 -9470.163)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12463",
    "data-name": "Group 12463"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37970",
    "data-name": "Path 37970",
    d: "M12139.89,9477.933c-1.6,1.416-26.6,24.9-26.6,24.9l14.49,7.668s15.948-30.118,15.948-30.523S12139.89,9477.933,12139.89,9477.933Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37971",
    "data-name": "Path 37971",
    d: "M12147.518,9498.859a14.233,14.233,0,0,1-4.935,9.709,13.379,13.379,0,0,1-6.263,3.013,23.443,23.443,0,0,1-6.623.535,7.6,7.6,0,0,1-2.336-.532,2.9,2.9,0,0,1-1.547-4.386c1.538-2.756,3.146-5.475,4.723-8.208l9.4-16.3a3.424,3.424,0,0,0,.066-3.718,3.1,3.1,0,0,0-3.088-1.583,5.156,5.156,0,0,0-1.871.7c-4.947,2.837-9.873,5.708-14.811,8.562-3.2,1.851-6.4,3.71-9.632,5.521a2.925,2.925,0,0,1-4.354-1.852,18.569,18.569,0,0,1-.408-4.39,21.181,21.181,0,0,1,.4-3.955,13.514,13.514,0,0,1,5.17-8.564,14.278,14.278,0,0,1,7.865-3c1.432-.093,2.865-.223,4.3-.23,5.193-.026,10.388-.019,15.582-.007a8.577,8.577,0,0,1,8.15,6.1,14.062,14.062,0,0,1,.447,3.411c.063,2.771.021,5.545.021,8.316C12147.8,9488,12147.782,9495.251,12147.518,9498.859Z",
    fill: "#3f7af5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37972",
    "data-name": "Path 37972",
    d: "M12109.278,9512.148c-.937,0-1.874-.016-2.812.006-.473.011-.672-.163-.662-.646.04-1.937.039-3.877.1-5.813a5.582,5.582,0,0,1,3.691-4.562,5.661,5.661,0,0,1,3.693,10.7,3.177,3.177,0,0,1-.873.259Z",
    fill: "#c3453b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "RACPAD",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12473",
    "data-name": "Group 12473",
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_37994",
    "data-name": "Path 37994",
    d: "M12160.066,9498.159v-14h6.84a5.708,5.708,0,0,1,1.949.319,4.643,4.643,0,0,1,1.53.891,4.024,4.024,0,0,1,1,1.37,4.251,4.251,0,0,1,.36,1.76,3.936,3.936,0,0,1-.75,2.36,4.456,4.456,0,0,1-1.991,1.54l3.1,5.76h-3.239l-2.741-5.36h-3.159v5.36Zm6.58-11.5h-3.681v3.76h3.681a2.29,2.29,0,0,0,1.569-.52,1.865,1.865,0,0,0,0-2.722A2.3,2.3,0,0,0,12166.646,9486.659Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37995",
    "data-name": "Path 37995",
    d: "M12172.5,9498.159l5.76-14h3.36l5.681,14h-3.141l-1.419-3.681h-5.781l-1.439,3.681Zm5.36-6h4l-1.98-5.16Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37996",
    "data-name": "Path 37996",
    d: "M12194.705,9495.678a4.673,4.673,0,0,0,2.06-.46,5.157,5.157,0,0,0,1.7-1.318l1.9,1.88a7.122,7.122,0,0,1-2.549,1.88,7.818,7.818,0,0,1-6.142.14,7.45,7.45,0,0,1-2.37-1.52,6.915,6.915,0,0,1-1.568-2.28,7.182,7.182,0,0,1,1.59-7.98,7.462,7.462,0,0,1,2.369-1.52,7.674,7.674,0,0,1,2.93-.56,7.865,7.865,0,0,1,3.26.71,6.87,6.87,0,0,1,2.561,1.909l-1.959,1.94a5.109,5.109,0,0,0-1.74-1.41,4.754,4.754,0,0,0-2.121-.49,4.5,4.5,0,0,0-1.77.351,4.359,4.359,0,0,0-1.431.96,4.414,4.414,0,0,0-.938,1.439,4.7,4.7,0,0,0-.34,1.811,4.523,4.523,0,0,0,.35,1.79,4.312,4.312,0,0,0,.959,1.43,4.55,4.55,0,0,0,1.441.95A4.618,4.618,0,0,0,12194.705,9495.678Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37997",
    "data-name": "Path 37997",
    d: "M12202.065,9498.159v-14h7.02a5.271,5.271,0,0,1,1.89.33,4.452,4.452,0,0,1,1.49.91,4.1,4.1,0,0,1,.97,1.39,4.413,4.413,0,0,1,.351,1.77,4.226,4.226,0,0,1-.351,1.73,4.093,4.093,0,0,1-.979,1.37,4.486,4.486,0,0,1-1.49.9,5.339,5.339,0,0,1-1.88.32h-4.12v5.28Zm6.7-11.5h-3.8v3.819h3.8a2.161,2.161,0,0,0,1.511-.52,1.775,1.775,0,0,0,.569-1.38,1.806,1.806,0,0,0-.569-1.39A2.131,2.131,0,0,0,12208.765,9486.659Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37998",
    "data-name": "Path 37998",
    d: "M12212.185,9498.159l5.762-14h3.359l5.681,14h-3.142l-1.42-3.681h-5.778l-1.441,3.681Zm5.36-6h4l-1.979-5.16Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37999",
    "data-name": "Path 37999",
    d: "M12228.165,9498.159v-14h5.38a7.834,7.834,0,0,1,2.92.54,7.265,7.265,0,0,1,2.352,1.479,6.916,6.916,0,0,1,2.129,5.021,6.662,6.662,0,0,1-.57,2.74,6.787,6.787,0,0,1-1.559,2.21,7.378,7.378,0,0,1-2.352,1.47,7.854,7.854,0,0,1-2.92.54Zm5.36-11.42h-2.459v8.84h2.459a4.462,4.462,0,0,0,3.14-1.271,4.254,4.254,0,0,0,.94-1.39,4.376,4.376,0,0,0,.34-1.72,4.567,4.567,0,0,0-.34-1.76,4.293,4.293,0,0,0-2.351-2.36A4.41,4.41,0,0,0,12233.525,9486.739Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRacLogo);
export default __webpack_public_path__ + "static/media/RAC-Logo.0e8d20ee.svg";
export { ForwardRef as ReactComponent };